import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import RecentNewsProxy from './proxy'

class RecentNewsService extends ServiceBase {
  getRecentNewsTable(params) {
    return this.getData(() => RecentNewsProxy.getRecentNewsTable(params))
  }
}

export default new RecentNewsService()
